import { useParams, useNavigate } from "react-router-dom";
import breakpoints from "assets/theme/base/breakpoints";
import AppList from "../AppList";
import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../../../../posnavbar/Navbar";
import {
  AppBar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UserContext } from "App";
import "./index.css";
import SoftSelect from "../../../../../../../components/SoftSelect";
import { emit } from "react-native-react-bridge/lib/web";
import { useSelector } from "react-redux";
import {
  getDeviceType,
  getMobilePos,
} from "../../../../all-products/redux/Reducers/paginationReducer";
import useGetDevice from "../../../../hooks/useGetDevice";

export const AppDetails = () => {
  const navigate = useNavigate();
  const { app } = useParams();
  const { color, setColor } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [printerStatus, setPrinterStatus] = useState("");
  const [labelPrinterStatus, setLabelPrinterStatus] = useState("");
  const [weighingScaleStatus,setWeighingScaleStatus] = useState('')
  const [optiondata, setOptiondata] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState({
    value: "Select Config...",
    label: "Select Config...",
  });
  const [appDetails, setAppDetails] = useState({
    name: "",
    urlName: "",
    overview: "",
    features: [],
    shortdescription: "",
    description: "",
    img: "",
    category: [],
  });
  const [value, setValue] = useState("description");
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [status, setStatus] = useState({
    tab1: true,
    tab2: false,
    tab3: false,
    tab4: false,
  });

  const isMobilePos = useSelector(getMobilePos);
  const deviceType = useSelector(getDeviceType);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleConfigChange = (event) => {
    setSelectedConfig(event);
    if (event?.value === "weighing-scale") {
      localStorage.setItem("scaleConfig", JSON.stringify(event));
      setWeighingScaleStatus(event);
    } else if (event?.printer === "TVS-LP46") {
      // Label printer is stored separately so it doesn't overwrite the receipt printer config
      localStorage.setItem("labelPrinterConfig", JSON.stringify(event));
      setLabelPrinterStatus(event);
    } else {
      localStorage.setItem("printerConfig", JSON.stringify(event));
      if (deviceType === "android") {
        emit({
          type: "localData",
          data: {
            printerConfig: event,
          },
        });
        if (event?.label === "Bluetooth") {
          emit({
            type: "connectPeripheral",
            data: {
              printerConfig: event,
            },
          });
        }
      }
      setPrinterStatus(event);
    }
  };

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (newValue == 0) {
      setStatus({
        tab1: true,
        tab2: false,
        tab3: false,
        tab4: false,
      });
    } else if (newValue == 1) {
      setStatus({
        tab1: false,
        tab2: true,
        tab3: false,
        tab4: false,
      });
    } else if (newValue == 2) {
      setStatus({
        tab1: false,
        tab2: false,
        tab3: true,
        tab4: false,
      });
    } else {
      setStatus({
        tab1: false,
        tab2: false,
        tab3: false,
        tab4: true,
      });
    }
  };

  useEffect(() => {
    const targetUrlName = (app === "thermal-posiflex" || app === "thermal-tvs") ? "thermal-printer" : app;
    const details = AppList.find((item) => item.urlName === targetUrlName);
    setAppDetails(details || {});
    setWeighingScaleStatus(JSON.parse(localStorage.getItem('scaleConfig')));
    if (app === "tvs-label-printer") {
      setLabelPrinterStatus(JSON.parse(localStorage.getItem("labelPrinterConfig")));
    }
    if (app === "thermal-posiflex") {
      setOptiondata([
        {
          value: "posiflex-usb",
          label: "USB port",
          printer: "Posiflex",
          instructions: (
            <ul>
              <li>Connect the printer to the USB port of the POSIFLEX terminal</li>
              <li>
                Install Zadig from this{" "}
                <a
                  href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  link
                </a>
              </li>

              <li>Open the application. From Options -&gt; List All Devices</li>
              <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width={"100%"} />
              <li>
                From the list, identify your printer. Make sure 'WinUSB' is selected from the target
                driver option below. Click Replace Driver.
              </li>
              <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width={"100%"} />
              <li>
                Once it is done, you can close the Zadig tool and the browser will be able to
                communicate with the Posiflex thermal printer.
              </li>
            </ul>
          ),
        },
        {
          value: "posiflex-serial",
          label: "Serial port",
          printer: "Posiflex",
          instructions: (
            <ul>
              <li>Connect the printer to the serial port of the POSIFLEX terminal</li>
            </ul>
          ),
        },
      ]);
    } else if (app === "thermal-tvs") {
      setOptiondata([
        {
          value: "tvs-usb",
          label: "USB port",
          printer: "TVS",
          instructions: (
            <ul>
              <li>Connect the printer to the USB port of the TVS terminal</li>
              <li>
                Install Zadig from this{" "}
                <a
                  href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  link
                </a>
              </li>

              <li>Open the application. From Options -&gt; List All Devices</li>
              <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width={"100%"} />
              <li>
                From the list, identify your printer. Make sure 'WinUSB' is selected from the target
                driver option below. Click Replace Driver.
              </li>
              <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width={"100%"} />
              <li>
                Once it is done, you can close the Zadig tool and the browser will be able to
                communicate with the TVS thermal printer.
              </li>
            </ul>
          ),
        },

        {
          value: "tvs-serial",
          label: "Serial port",
          printer: "TVS",
          instructions: (
            <ul>
              <li>Connect the printer to the serial port of the TVS terminal</li>
            </ul>
          ),
        },
      ]);
    } else if (app === "thermal-shreyans") {
      setOptiondata([
        {
          value: "shreyans-bluetooth",
          label: "Bluetooth",
          printer: "Shreyans",
          instructions: (
            <ul>
              {" "}
              <li>
                Ensure your laptop's Bluetooth is turned on, but do not connect to bluetooth from
                there.
              </li>{" "}
              <li>
                Select "Bluetooth" from the dropdown menu above, then click the "Select" button
                below.
              </li>{" "}
              <li>When printing in Chrome, choose "MPT-II" from the pop-up options.</li>
            </ul>
          ),
        },
      ]);
    }
    else if (app === "tvs-label-printer") {
      setOptiondata([
        {
          value: "tvs-label-usb",
          label: "USB port",
          printer: "TVS-LP46",
          instructions: (
            <ul>
              <li>Connect the TVS LP 46 LITE to the USB port of your device</li>
              <li>
                Install Zadig from this{" "}
                <a
                  href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  link
                </a>
              </li>
              <li>Open the application. From Options &rarr; List All Devices</li>
              <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width={"100%"} />
              <li>
                From the list, find <strong>"USB Printing Support"</strong> or{" "}
                <strong>"Bar Code Printer TT065-50"</strong>. Make sure{" "}
                <strong>WinUSB (Microsoft)</strong> is selected as the target driver, then click{" "}
                <strong>Replace Driver</strong>.
              </li>
              <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width={"100%"} />
              <li>
                Once done, close Zadig. The browser will now be able to communicate with the TVS
                LP 46 LITE label printer via WebUSB.
              </li>
              <li>
                Go to <strong>Printer Configuration</strong> in settings and click{" "}
                <strong>Test Label Print</strong> to verify the connection.
              </li>
            </ul>
          ),
        },
      ]);
    }
    else if (app === "weighing-scale") {
      setOptiondata([
        {
          value: "weighing-scale",
          label: "Usb port",
          printer: "Prrestige",
          instructions: (
            <ul>
              {" "}
              <li>Keep the usb of weighing device connected to the laptop</li>{" "}
              <li>When adding a weighing product ,a pop up will appear for the first time</li>{" "}
              <li>
                Select your weighing scale from there, pair it and the weight will be populated
              </li>
            </ul>
          ),
        },
      ]);
    }
    if (appDetails?.category?.includes("Thermal Printer")) {
      setPrinterStatus(JSON.parse(localStorage.getItem("printerConfig")));
    }
  }, []);

  const handleButtonClick = (componentName) => {
    setValue(componentName);
  };

  const renderComponent = () => {
    switch (value) {
      case "description":
        return <Description />;
      case "keyFeatures":
        return <KeyFeatures />;
      case "instructions":
        return <Instructions />;
      default:
        return null;
    }
  };

  const Description = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={12}>
          <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: "10px",
              }}
            >
              Overview
            </Typography>
            <Typography style={{ fontSize: "14px" }}>{appDetails?.overview}</Typography>
          </Grid>
          <br />
          <Box>
            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: "10px",
              }}
            >
              Features
            </Typography>
            <Box>
              <ul>
                {appDetails?.features.map((list, index) => (
                  <li key={index} style={{ fontSize: "13px" }}>
                    {list}
                  </li>
                ))}
              </ul>
            </Box>
          </Box>

          <br />
        </Grid>
      </Grid>
    );
  };

  const KeyFeatures = () => {
    return (
      <Box>
        <Typography
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "uppercase",
            marginBottom: "10px",
          }}
        >
          How to get started
        </Typography>
        <br />
        <Typography style={{ fontSize: "14px" }}>
          New to PaytmPG? Use this <a href="/">link </a>
          to create your Paytm for Business account and get access to exciting offers.
        </Typography>
        <br />
        <Typography style={{ fontSize: "14px" }}>
          Before enabling the Paytm Payment Gateway on Pallet, make sure you have a registered
          business account with Paytm. Please visit – Paytm Dashboard{" "}
          <a href="/">Paytm Dashboard </a>
          to sign-up
        </Typography>
      </Box>
    );
  };

  const Instructions = () => {
    return (
      <Typography
        style={{
          fontSize: "14px",
        }}
      >
        Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus.
        Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla
        mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum
        sodales, augue velit cursus nunc,
      </Typography>
    );
  };
  return (
    <Navbar>
      <Card
        style={{
          padding: "2rem",
          width: "100%",
          backgroundColor: "white",
          marginTop: "70px",
          marginBottom: "70px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item>
            <img className="app-logo" src={appDetails?.img} />
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: window.innerWidth < breakpoints.values.sm ? "column" : "row",
              justifyContent: "space-between",
              alignItems: window.innerWidth < breakpoints.values.sm ? "flex-start" : "center",
              width: "100%",
            }}
            item
            lg={12}
            xl={12}
            mb={5}
          >
            <Box>
              <Typography variant="h5" fontWeight={"bold"} mb={2}>
                {" "}
                {appDetails?.name}
              </Typography>
              <Typography style={{ fontSize: "14px", color: "#6B6B6B" }} variant="h7">
                {appDetails?.description}
              </Typography>
            </Box>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              justifyContent="flex-end"
              sx={{ width: { xs: "100%", md: "40%" } }}
            >
              {app === "tvs-label-printer" ? (
                labelPrinterStatus && (
                  <Typography style={{ fontSize: "13px", color: "limegreen" }}>
                    {`${labelPrinterStatus?.printer} - ${labelPrinterStatus?.label} selected. Please ensure the label printer is connected.`}
                  </Typography>
                )
              ) : (
                printerStatus && (
                  <Typography style={{ fontSize: "13px", color: "limegreen" }}>
                    {`${printerStatus?.printer} - ${printerStatus?.label} selected. Please ensure that the printer is connected to the device.`}
                  </Typography>
                )
              )}

                {
                  appDetails?.urlName !=='weighing-scale' && (
                    <button
                className="btn"
                style={{ marginLeft: "15px", textTransform: "uppercase" }}
                onClick={() => setOpenModal(true)}
                autoFocus
              >
                {" "}
                {app === "tvs-label-printer"
                  ? labelPrinterStatus ? "Edit" : "Connect"
                  : printerStatus ? "Edit" : "Connect"}
              </button>
                  )
                }

              {appDetails?.urlName == "weighing-scale" && (
                <button
                  className="btn"
                  style={{ marginLeft: "15px", textTransform: "uppercase" }}
                  onClick={() => setOpenModal(true)}
                  autoFocus
                >
                  {" "}
                  {weighingScaleStatus ? "Edit" : "Connect"}
                </button>
              )}
            </Stack>
            {openModal && (
              <div>
                <Modal open={openModal} onClose={handleModalClose}>
                  <Box
                    sx={{
                      backgroundColor: color === "dark" ? "#353a50" : "#fff",
                      color: color === "dark" ? "white" : "black",
                      padding: "2%",
                      borderRadius: "10px",
                      width: "50%",

                      maxWidth: "100vw",
                      maxHeight: "100%",
                      minHeight: "300px",
                      minWidth: "250px",
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      overflowY: "auto",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <IconButton sx={{ float: "right" }} onClick={handleModalClose}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </div>
                    <h3 className="addCustomerText" style={{ marginBottom: "0.2rem" }}>
                      Select Printer Configuration
                    </h3>
                    <h5 style={{ marginBottom: "1rem", color: "gray" }}>{appDetails?.model}</h5>
                    <div className="mrp-option-wrapper-box">
                      <SoftSelect
                        options={optiondata}
                        placeholder="Select Config"
                        value={selectedConfig}
                        onChange={handleConfigChange}
                        sx={{
                          width: { xs: "100%", md: "auto" },
                          fontSize: { xs: "12px", md: "14px" },
                        }}
                      />
                      {selectedConfig?.instructions && (
                        <>
                          <Typography
                            style={{
                              fontSize: "14px",
                              margin: "1rem 0",
                            }}
                          >
                            Instructions
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "14px",
                              color: "#6B6B6B",
                            }}
                            component={"span"}
                          >
                            {selectedConfig?.instructions}
                          </Typography>
                        </>
                      )}

                      <button
                        style={{ marginTop: "50px" }}
                        className="btn"
                        onClick={handleModalClose}
                      >
                        SELECT
                      </button>
                    </div>
                  </Box>
                </Modal>
              </div>
            )}
          </Grid>
          {/* <Grid item>
            <Button color="info" variant="gradient" style={{ marginLeft: "50px" }}>
              Install
            </Button>
          </Grid> */}
        </Grid>

        <Grid item xs={12} md={6} lg={5}>
          <AppBar
            position="static"
            className="appbar"
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <Tabs
              orientation={tabsOrientation}
              value={tabValue}
              onChange={handleSetTabValue}
              // TabIndicatorProps={{
              //   sx: {
              //     left: 0,
              //     position: 'absolute',
              //     bottom: '0px',
              //     width: '100%',
              //     height: '100%',
              //     borderRadius: '0.5rem',
              //     backgroundColor: 'rgb(255, 255, 255)',
              //     boxShadow: 'rgb(221, 221, 221) 0rem 0.0625rem 0.3125rem 0.0625rem',
              //     transition: 'all 500ms ease 0s',
              //   },
              // }}
            >
              <Tab
                sx={{ flex: 1 }}
                label="About"
                onClick={() => handleButtonClick("description")}
              />
              <Tab
                sx={{ flex: 1 }}
                label="Instructions"
                onClick={() => handleButtonClick("keyFeatures")}
              />
              <Tab
                sx={{ flex: 1 }}
                label="Pricing"
                onClick={() => handleButtonClick("instructions")}
              />
            </Tabs>
          </AppBar>
        </Grid>

        <hr style={{ margin: 0 }} />

        <Grid item xs={12} sm={8} md={8} lg={8} mt={2} p={2}>
          {status.tab1 ? <Typography variant="h5"></Typography> : null}
          {status.tab2 ? <Typography variant="h5"></Typography> : null}
          {status.tab3 ? <Typography variant="h5"></Typography> : null}

          {renderComponent()}
        </Grid>
        <div style={{ marginTop: "2rem" }}>
          <button className="btn" style={{ marginLeft: "15px" }} onClick={() => navigate(-1)}>
            GO BACK
          </button>
        </div>
      </Card>
    </Navbar>
  );
};
